import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { isEmpty } from 'lodash';
import React from 'react';

/**
 * ExpansionRow
 *
 * Expands/opens a table row on click.
 *
 * @param args
 * @returns {JSX.Element|string}
 * @constructor
 */
export function ExpansionRow(args) {
  const { theRow } = args;

  if (!isEmpty(theRow?.ids)) {
    return (
      <ErrorHandler location="src/entities/RiskRecord/ui/components/tables/TrustedSources/components/ExpansionRow/ExpansionRow.jsx">
        <Grid css={{ margin: 0 }}>
          <Grid.Col
            span={{
              xs: '100%',
            }}
          >
            <Layout.Stack alignItems="left" grow>
              {theRow?.ids.map((id) => {
                return (
                  <div key={id}>
                    <strong>ID:</strong> <code>{id}</code>
                  </div>
                );
              })}
            </Layout.Stack>
          </Grid.Col>
        </Grid>
      </ErrorHandler>
    );
  }

  return '';
}
